






import { Component, Mixins, Prop, Vue } from "vue-property-decorator";
import { ContentMixin } from "./mixins";
import { default as WizardContentContainer } from "./WizardContentContainer.vue";
import { default as WizardContentHorizontalContainer } from "./WizardContentHorizontalContainer.vue";
import { default as WizardContentStackContainer } from "./WizardContentStackContainer.vue";
import { default as WizardContentPatientIndicator } from "./WizardContentPatientIndicator.vue";
import { default as WizardContentFormatIndicator } from "./WizardContentFormatIndicator.vue";
import { default as WizardContentHeadingIndicator } from "./WizardContentHeadingIndicator.vue";
import { default as WizardContentFixedTextIndicator } from "./WizardContentFixedTextIndicator.vue";
import { default as WizardContentMediaIndicator } from "./WizardContentMediaIndicator.vue";
import { default as WizardContentTextEditor } from "./WizardContentTextEditor.vue";
import { default as WizardContentTextInput } from "./WizardContentTextInput.vue";
import { default as WizardContentNumberInput } from "./WizardContentNumberInput.vue";
import { default as WizardContentBarInput } from "./WizardContentBarInput.vue";
import { default as WizardContentDateInput } from "./WizardContentDateInput.vue";
import { default as WizardContentRadioSelector } from "./WizardContentRadioSelector.vue";
import { default as WizardContentCheckSelector } from "./WizardContentCheckSelector.vue";
import { default as WizardContentImageFileSelector } from "./WizardContentImageFileSelector.vue";
import { default as WizardContentImageCaptureInput } from "./WizardContentImageCaptureInput.vue";
import { default as WizardContentImageSignInput } from "./WizardContentImageSignInput.vue";
import { default as WizardContentClaioImageSelector } from "./WizardContentClaioImageSelector.vue";
import { default as WizardContentClaioSchemaSelector } from "./WizardContentClaioSchemaSelector.vue";
import { default as WizardContentMediaRemover } from "./WizardContentMediaRemover.vue";
import { default as WizardContentMediaRotater } from "./WizardContentMediaRotater.vue";
import { default as WizardContentNotImplemented } from "./WizardContentNotImplemented.vue";
import { default as WizardContentTextIndicator } from "./WizardContentTextIndicator.vue";
import { default as WizardContentUserSelector } from "./WizardContentUserSelector.vue";
import { default as WizardContentLoginUserSelector } from "./WizardContentLoginUserSelector.vue";
import { default as WizardContentRadioSelectors } from "./WizardContentRadioSelectors.vue";
import { IExecutable, instanceOfIExecutable } from "./IExecutable";

@Component({
  components: {
    "container": WizardContentContainer,
    "horizontal-container": WizardContentHorizontalContainer,
    "stack-container": WizardContentStackContainer,
    "patient-indicator": WizardContentPatientIndicator,
    "format-indicator": WizardContentFormatIndicator,
    "heading-indicator": WizardContentHeadingIndicator,
    "fixed-text-indicator": WizardContentFixedTextIndicator,
    "media-indicator": WizardContentMediaIndicator,
    "text-editor": WizardContentTextEditor,
    "text-input": WizardContentTextInput,
    "number-input": WizardContentNumberInput,
    "bar-input": WizardContentBarInput,
    "date-input": WizardContentDateInput,
    "radio-selector": WizardContentRadioSelector,
    "check-selector": WizardContentCheckSelector,
    "image-file-selector": WizardContentImageFileSelector,
    "image-capture-input": WizardContentImageCaptureInput,
    "image-sign-input": WizardContentImageSignInput,
    "claio-image-selector": WizardContentClaioImageSelector,
    "claio-schema-selector": WizardContentClaioSchemaSelector,
    "media-remover": WizardContentMediaRemover,
    "media-rotater": WizardContentMediaRotater,
    "not-implemented": WizardContentNotImplemented,
    "text-indicator": WizardContentTextIndicator,
    "user-selector": WizardContentUserSelector,
    "login-user-selector": WizardContentLoginUserSelector,
    "radio-selectors": WizardContentRadioSelectors,
  }
})
export default class WizardContent extends Mixins(ContentMixin) implements IExecutable {
  @Prop()
  scale: number;

  $refs!: {
    content: Vue,
  };

  get type(): string {
    switch (this.content.type) {
      case "container":
      case "horizontal-container":
      case "stack-container":
      case "patient-indicator":
      case "format-indicator":
      case "heading-indicator":
      case "fixed-text-indicator":
      case "media-indicator":
      case "text-editor":
      case "text-input":
      case "date-input":
      case "number-input":
      case "bar-input":
      case "radio-selector":
      case "check-selector":
      case "image-file-selector":
      case "image-capture-input":
      case "image-sign-input":
      case "claio-image-selector":
      case "claio-schema-selector":
      case "media-remover":
      case "media-rotater":
      case "text-indicator":
      case "user-selector":
      case "login-user-selector":
      case "radio-selectors":
        return this.content.type;
      default:
        return "not-implemented";
    }
  }

  get additionalClass(): string {
    return this.isEnable
      ? ""
      : "disabled";
  }

  get contentStyle() {
    return {
      paddingTop: this.margin.top,
      paddingLeft: this.margin.left,
      paddingBottom: this.margin.bottom,
      paddingRight: this.margin.right,
      fontSize: this.fontSize ? `calc(${this.fontSize}*${this.scale})` : undefined,
    };
  }

  get fontSize(): string {
    return this.content && this.content.attributes
      ? this.content.attributes.fontSize
      : "";
  }

  async execute() {
    if (instanceOfIExecutable(this.$refs.content)) {
      await this.$refs.content.execute();
    }
  }
}
